import React from 'react';
import { cn, createIconElement } from '@/lib';
import OnboardingStanley from '@/assets/icons/onboarding-stanley.svg';

interface AskStanleyFloatingButtonProps {
    onClick: () => void;
    isOpen: boolean;
    className?: string;
}

export const AskStanleyFloatingButton: React.FC<AskStanleyFloatingButtonProps> = ({
    onClick,
    isOpen,
    className = '',
}) => {
    return (
        <button
            onClick={onClick}
            className={cn(
                'z-tooltip fixed flex cursor-pointer items-center justify-center rounded-full shadow-lg transition-all duration-300 ease-in-out hover:scale-105 focus:ring-2 focus:ring-offset-2 focus:outline-none',
                'from-brand-main to-brand-soft hover:from-brand-main hover:to-brand-hover focus:ring-brand-main bg-gradient-to-br',
                'text-canvas',
                'right-4 bottom-[77px] lg:right-6 lg:bottom-6',
                'size-12',
                isOpen ? 'pointer-events-none scale-95 opacity-0' : 'scale-100 opacity-100',
                className
            )}
            aria-label='Ask Stanley'
        >
            {/* Stanley Icon */}
            {createIconElement(OnboardingStanley, { className: 'size-6 text-canvas' })}
        </button>
    );
};
